const A = {
  imt_effective_pct: 7.0,
  stamp_duty_pct: 0.8,
  notary_eur: 800,
  lawyer_eur: 3500,
  registration_eur: 250,
  vpt_to_market_ratio: 0.60,
  aimi_threshold_eur: 600000,
  aimi_pct: 0.4,
  maintenance_pct_yearly: 1.5,
  retreat_opex_pct_of_revenue: 30,
  master_bedroom_held_back: 1,
  season_days: { peak: 60, shoulder: 120, winter: 185 },
};

export function costModel(purchasePrice, bedrooms, concelhoFacts) {
  if (!purchasePrice || purchasePrice <= 0) return null;
  const facts = concelhoFacts || {};
  const biz = facts.business || null;

  const imt = Math.round(purchasePrice * A.imt_effective_pct / 100);
  const stamp_duty = Math.round(purchasePrice * A.stamp_duty_pct / 100);
  const acquisition_extra = imt + stamp_duty + A.notary_eur + A.lawyer_eur + A.registration_eur;
  const acquisition_grand_total = purchasePrice + acquisition_extra;

  const vpt = Math.round(purchasePrice * A.vpt_to_market_ratio);
  const imi_rate = facts.imi_rate_2025 ?? 0.40;
  const imi = Math.round(vpt * imi_rate / 100);
  const aimi = vpt > A.aimi_threshold_eur
    ? Math.round((vpt - A.aimi_threshold_eur) * A.aimi_pct / 100) : 0;
  const maintenance = Math.round(purchasePrice * A.maintenance_pct_yearly / 100);
  const utilities = biz?.utilities_yearly_eur ?? 5000;
  const annual_total = imi + aimi + maintenance + utilities;

  let revenue = null;
  const rentable = bedrooms ? Math.max(0, bedrooms - A.master_bedroom_held_back) : 0;
  if (rentable > 0 && biz?.nightly_rate_eur_avg) {
    const rate = biz.nightly_rate_eur_avg;
    const peak = Math.round(rentable * A.season_days.peak * rate * (biz.peak_occupancy_pct ?? 70) / 100);
    const shoulder = Math.round(rentable * A.season_days.shoulder * rate * (biz.shoulder_occupancy_pct ?? 45) / 100);
    const winter = Math.round(rentable * A.season_days.winter * rate * (biz.winter_occupancy_pct ?? 18) / 100);
    const gross = peak + shoulder + winter;
    const opex = Math.round(gross * A.retreat_opex_pct_of_revenue / 100);
    revenue = {
      gross, opex, net: gross - opex,
      rentable_rooms: rentable, rate,
      peak, shoulder, winter,
      peak_occ: biz.peak_occupancy_pct, shoulder_occ: biz.shoulder_occupancy_pct, winter_occ: biz.winter_occupancy_pct,
    };
  }

  const net_cashflow_yearly = (revenue ? revenue.net : 0) - annual_total;
  const breakEvenYears = (revenue && net_cashflow_yearly > 0)
    ? Math.ceil(acquisition_grand_total / net_cashflow_yearly) : null;

  return {
    purchase_price: purchasePrice,
    acquisition: { imt, stamp_duty, notary: A.notary_eur, lawyer: A.lawyer_eur, registration: A.registration_eur, extra: acquisition_extra, grand_total: acquisition_grand_total },
    annual: { imi, aimi, maintenance, utilities, total: annual_total },
    vpt, imi_rate,
    revenue,
    net_cashflow_yearly,
    breakEvenYears,
  };
}
